"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Card extends React.Component {
    render() {
        const { alternate, image, title, subtitle, link, openInNewWindow } = this.props;
        return (React.createElement("a", { href: link, target: openInNewWindow ? "_blank" : "", className: `Card ${alternate ? 'alternate' : ''}` },
            React.createElement("i", { className: "card-image", style: { backgroundImage: `url(${image})` } }),
            subtitle && (React.createElement("h3", { className: "card-subtitle" }, subtitle)),
            title && (React.createElement("h2", { className: `card-title` }, title))));
    }
}
exports.Card = Card;
exports.default = Card;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-card/Card.tsx